var map = {
	"./Colorful": 67551,
	"./Colorful.js": 67551,
	"./Colorful.module.css": 59731,
	"./DisplayItems": 77201,
	"./DisplayItems.js": 77201,
	"./DisplayItems.module.css": 88555,
	"./InsertText": 57339,
	"./InsertText.js": 57339,
	"./InsertText.module.css": 75383,
	"./ReadItOut": 14562,
	"./ReadItOut.js": 14562,
	"./ReadItOut.module.css": 86754,
	"./WordBlendFlow": 28418,
	"./WordBlendFlow.jsx": 28418,
	"./WordBlendFlow.module.css": 71326,
	"./clusterSpreadCvc/ClusterSpreadCvc": 986,
	"./clusterSpreadCvc/ClusterSpreadCvc.jsx": 986,
	"./clusterSpreadCvc/ClusterSpreadCvc.module.css": 16226,
	"./clusterSpreadCvc/InteractiveTapStepRow": 53722,
	"./clusterSpreadCvc/InteractiveTapStepRow.jsx": 53722,
	"./clusterSpreadCvc/tapSteps": 78375,
	"./clusterSpreadCvc/tapSteps.js": 78375
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 48057;